// extracted by mini-css-extract-plugin
module.exports = {"containerTemplate":"ContainerTemplate_containerTemplate__3vb7Q","header":"ContainerTemplate_header__3_Vwm","footer":"ContainerTemplate_footer__1TxZo"};